module.exports = __webpack_public_path__ + "img/TV_clean_box19.9336abdb.jpg";